import { deepCopy } from './utils';

export function getSearchControlsFromStorage () {
  const searchControls = localStorage.getItem('__SEARCH_CONTROLS__');
  if (searchControls) {
    return JSON.parse(searchControls);
  }
  return {};
}

export function setSearchControlsToStorage (controls) {
  const searchControls = JSON.stringify(controls);
  localStorage.setItem('__SEARCH_CONTROLS__', searchControls);
}

export function prepareSearchControls (controls, gender) {
  const newControls = deepCopy(controls);

  Object.keys(newControls).forEach(key => {
    if (key === 'distance') {
      newControls[key].value = newControls[key].options.max;
    } else if (key === 'gender') {
      newControls[key].value = gender;
    } else if (key === 'hasphoto') {
      newControls[key].value = 'no';
    } else if (key === 'height' || key === 'age') {
      newControls[key].value = [newControls[key].options.min, newControls[key].options.max];
    } else {
      newControls[key].value = [];
    }
  });

  return newControls;
}

export function getSearchValues (controls) {
  const obj = {};

  Object.keys(controls).forEach(key => {
    if (typeof controls[key].value === 'string' || typeof controls[key].value === 'number') {
      obj[`ext[${key}]`] = controls[key].value;
    } else if (Array.isArray(controls[key].value) && controls[key].value.length > 0) {
      obj[`ext[${key}]`] = controls[key].value.join(',');
    }
  });

  return obj;
}

export function formatHeight (value) {
  const realFeet = value / 12;
  const feet = Math.floor(realFeet);
  const inches = Math.round((realFeet - feet) * 12);

  return feet + '’ ' + inches;
}

export function formatHeightMetric (value, addCm = true) {
  return parseInt(value * 2.54, 10) + (addCm ? ' cm' : '');
}

export function getHeightArray (min, max) {
  const heightArray = [];

  for (let i = min; i <= max; i++) {
    heightArray.push(i);
  }

  return heightArray;
}



// WEBPACK FOOTER //
// ./src/assets/helpers/searchHelper.js